
function initializeTypePreference() {
 var preference = getCurrentTypePreference()
 showDeckContainerTab(preference);
}

var showDeckContainerTab = function(preference) {
  $('.type-switcher-tabs > li > a').each(function() {
    if ($(this).attr("href").match("tab-" + preference)) {
      $(this).tab('show') ;
    }
  });
}
function initializeDeckComponents(tabId, deckId, deckString, viewModeOverride) {
  //console.log("initializeDeckComponents tabId=" + tabId)
  var type = "";
  
  //console.log("initializeDeckComponents deckId=" + deckId);
  //console.log("initializeDeckComponents deckString=" + deckString);
  var deckStringIfNoDeckId = (deckId == null || deckId =="") ? deckString : ""
  //console.log("initializeDeckComponents deckStringIfNoDeckId=" + deckStringIfNoDeckId);
  $(document).on('shown.bs.tab', `#${tabId} a[data-toggle="tab"]`, function(e) {
    //console.log("shown.bs.tab happened")
  //$(`#${tabId} a[data-toggle="tab"]`).on('shown.bs.tab', function(e) {
    var tab = $(e.target.hash);
    if (tab.data("my-price") && !tab.data("loaded")) {
      type = tab.data("type");
      // send AJAX request
      $.ajax({
        url: '/deck/my_price_js',
        type: "GET",
        dataType: "script",
        data: {
          type: type,
          id: deckId,
          deck: deckStringIfNoDeckId,
          selector: e.target.hash,
          view_mode_override: viewModeOverride,
        },
        context: this,
      });
    } else if (tab.data("deck-component") && !tab.data("loaded")) {
      type = tab.data("type");
      // send AJAX request
      $.ajax({
        url: '/deck/component',
        dataType: "script",
        data: {
          id: deckId,
          type: type,
          deck: deckStringIfNoDeckId,
          selector: e.target.hash,
          view_mode_override: viewModeOverride,
        },
        context: this,
      });
    } else if (tab.data("deck-stats") && !tab.data("loaded")) {
      type = tab.data("type");
      // send AJAX request
      $.ajax({
        url: '/deck/stats',
        dataType: "script",
        data: {
          id: deckId,
          type: type,
          deck: deckStringIfNoDeckId,
          selector: e.target.hash,
          view_mode_override: viewModeOverride,
        },
        context: this,
      });
    }
  })
}


var getCurrentTypePreference = function() {
  var url = document.location.toString();
  if (url.match('#')) {
    return url.split('#')[1];
  } else {
    var preference = Cookies.get('type-preference');
    if (preference == "online") {
    } else if (preference == "arena") {
    } else {
      preference = "paper";
    }
    return preference;
  } 
}
window.getCurrentTypePreference = getCurrentTypePreference

function splitDecklistsIntoTwoColumns() {
  // only do for firefox and desktop
  if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 && window.matchMedia("screen and (min-width: 900px)").matches) {
    $(".deck-table-container").each(function() {
      var container = $(this);
      if (container.length == 1) {
        var table = $(this).find(".deck-view-deck-table");
        var secondTable = $(table[0].cloneNode())

        var numChildren = table.find("tr").length
        var rowCount = Math.round(numChildren * 0.5);

        var rows = table.find("tr").slice(rowCount);

        secondTable.append("<tbody></tbody>");
        secondTable.find("tbody").append(rows);

        table.parent().append(secondTable);
        table.find("tr").slice(rowCount).remove();
      }
    });
  }
}

window.MTGGoldfish = MTGGoldfish || {};
window.MTGGoldfish.onDocumentReadyArray = window.MTGGoldfish.onDocumentReadyArray || [];
window.MTGGoldfish.onDocumentReadyArray.push(function() { 
  splitDecklistsIntoTwoColumns();
  $(document).on('click', '.decklist-more', function (e) {
    $(e.target).hide();
    $(e.target).closest(".decklist-more-container").find(".decklist-purchase-more").show();
  });
  $(document).on('click', '.deck-tools-btn-download-submit', function (e) {
    e.preventDefault();
    $(this).closest('form').find(".field-output").val($(this).data("output"));
    $(this).closest('form').find(".field-type").val($(this).data("type"));
    $(this).closest('form').submit();
  });
  $(".copy-paste-box").each(function(e){
     $(this).height(($(this).prop('scrollHeight'))+"px");
  });
  $(".copy-paste-box").click(function(e){
    $(this).select();
  });
  $(".my-decks-btn-add").click(function(e) {
    var target = $(e.target).data("target");
    var textarea = $('#' + target);
    var card = $('.add-card-' + target).val();
    var qty = $('.add-qty-' + target).val();
    textarea.val(textarea.val() + "\n" + qty + " " + card);
  });
  $(".auto-select-text").click(function(e){
    $(this).select();
  });
  function showDecksTab(panelName, context) {
      $("#search-filter-panel").val(panelName);

      const csrfToken = document.querySelector('meta[name="csrf-token"]').content;
      const params = new URLSearchParams({ panel: panelName });
      const url = `/decks?${params.toString()}`;

      fetch(url, {
        method: 'GET', // or 'GET' if appropriate
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
          'Accept': 'text/vnd.turbo-stream.html',
          'X-CSRF-Token': csrfToken
        },
        credentials: 'same-origin' // ensures cookies/session are sent
      })
      .then(response => {
        if (!response.ok) throw new Error("Turbo Stream request failed");
        return response.text();
      })
      .then(html => {
        Turbo.renderStreamMessage(html); // applies Turbo Stream DOM changes
      })
      .catch(error => {
        console.error(error);
      });
  }

  $(document).on('shown.bs.tab', '#mydecks-tabs a[data-toggle="tab"]', function (e) {
    if (e.target.hash != "#tab-search") {
      showDecksTab(e.target.hash, this);
    }

    // erase contents
    if (e.relatedTarget && e.relatedTarget.hash) {
      if (e.target.hash == "#tab-search") {
        $(e.relatedTarget.hash).html("<p class='empty'>Search Results have expired. Please search again.</p>");
      } else {
        $(e.relatedTarget.hash).html("<p class='empty'>Loading ...</p>");
      }
    }
  });

  $(document).on('click', '.hidden-form-submit', function (e) {
		var hiddenForm = $(this).find(".hidden-form");
    var f = $("<form target='_blank' method='POST' style='display:none;'></form>").attr({
        action: hiddenForm.data("url"),
    }).appendTo(document.body);

		hiddenForm.find(".hidden-form-input").each(function() {
			$('<input type="hidden" />').attr({
					name: $(this).data("name"),
					value: $(this).data("value"),
			}).appendTo(f);
		});
    f.submit();
    f.remove();
  });


});

window.initializeDeckComponents = initializeDeckComponents;
window.splitDecklistsIntoTwoColumns = splitDecklistsIntoTwoColumns;
window.initializeTypePreference = initializeTypePreference;
